import {Component, Input} from '@angular/core';
import {ReferenceDataService} from "../../../../../../services/reference-data.service";
import {UidService} from "../../../../../../services/uid.service";
import {FormArray, FormGroup} from "@angular/forms";
import {FormService} from "../../../../../../services/form.service";

@Component({
  selector: 'rb-forest-managers-data',
  templateUrl: './forest-managers-data.component.html',
  styleUrls: ['./forest-managers-data.component.scss']
})
export class ForestManagersDataComponent {
  @Input() data: FormGroup;
  uid: number;

  constructor(
    public referenceDataService: ReferenceDataService,
    private uidService: UidService,
    public formService: FormService
  ) {
    this.uid = uidService.generateUid();
  }

  hasControls(): boolean {
    return !!(this.data.controls.certificationRecords as FormArray).length
      || !!(this.data.controls.legalRightToHarvestRecords as FormArray).length
      || !!(this.data.controls.legalityOfHarvestRecords as FormArray).length
      || !!(this.data.controls.paymentOfTaxesAndRoyaltiesRecords as FormArray).length;
  }
}
